import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'COUPON_UPDATE',
    smsDelete : 'COUPON_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        coupon: [],

        submitSuccess: false,
        couponLoading: false,
        couponError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_COUPON(state, coupon) {
            state.coupon = coupon;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        COUPON_LOADING (state, loading) {
            state.couponLoading = loading;
        },

        COUPON_ERROR (state, hasError) {
            state.couponError = hasError;
        }
    },

    actions: {
        async addCoupon ({commit, dispatch}, payload) {
            commit('COUPON_LOADING', true);
            commit('COUPON_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_coupon, payload.coupon, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCoupon')
                return response

            } catch (e) {
                commit('COUPON_ERROR', true);
            } finally {
                commit('COUPON_LOADING', false);
            }
        },

        async fetchCoupon ({ commit }) {
            commit('COUPON_LOADING', true);
            commit('COUPON_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.coupon_list, config);
                let response = result.data
                commit('SET_COUPON', response.data);

            } catch(error) {
                commit('COUPON_ERROR', true);
            } finally {
                commit('COUPON_LOADING', false);
            }
        },

        async updateCoupon ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_coupon + payload.id, payload.coupon, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCoupon')
                return response

            } catch (e) {
                commit('COUPON_ERROR', true);
            } finally {
                commit('COUPON_LOADING', false);
            }
        },
        
        async deleteCoupon({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.coupon_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCoupon')
            return response
        }
    },

    getters: {}
}
